<template>
    <v-row justify="center">
        <v-dialog
        v-model="warningDialog"
        max-width="290"
        >
        <v-card>
            <v-card-title class="headline">
            Warning
            </v-card-title>
            <v-card-text>You are currently inactive. If there is no activity within the next 1 minute, you will be logged out.</v-card-text>
        </v-card>
        </v-dialog>
        <v-dialog
        v-model="logoutDialog"
        max-width="290"
        >
        <v-card>
            <v-card-title class="headline">
            Warning
            </v-card-title>
            <v-card-text>Your Session Has Timed Out. Please login again to continue.</v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
                <v-btn
                    color="green darken-1"
                    text
                    @click="logoutDialog = false"
                >
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

    </v-row>

</template>

<script>

export default {
  name: 'LogoutTimer',
  data () {
    return{
        events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
        warningTimer: null,
        logoutTimer: null,
        logoutDialog: false,
        warningDialog: false
    }
  },
  mounted(){
      this.events.forEach(function (event){
          window.addEventListener(event, this.resetTimer)
      }, this);

      this.setTimers();
  },

  destroyed () {
      this.resetTimers(function (event){
          window.removeEventListener(event, this.resetTimer)
      }, this);

      this.resetTimer();
  },
  methods: {
      setTimers: function() {
          this.warningTimer = setTimeout(this.warningMessage, 900*1000)
          this.logoutTimer = setTimeout(this.logoutUser, 960*1000)
      },
      warningMessage: function () {
          if(this.$store.state.isUserLoggedIn){
            this.warningDialog = true
          }
      },
      logoutUser: function () {
          if (this.$store.state.isUserLoggedIn){
            this.$store.dispatch('setToken', null)
            this.$store.dispatch('setUser', null)
            this.$store.dispatch('setAdmin', false)
            this.$store.dispatch('setSuperAdmin', false)
            this.$store.dispatch('logout')
            this.$router.push({
                name: 'login'
        })
           this.warningMessage = false
           this.logoutDialog = true
          }
          this.resetTimer()
      },
      resetTimer: function () {
        clearTimeout(this.warningTimer)
        clearTimeout(this.logoutTimer)
        this.warningDialog = false
        this.setTimers()
      }
    } 
  }

</script>

<style scoped>

</style>
